﻿import { fieldsProxy } from "@serenity-is/corelib/q";

export interface ExceptionsRow {
    Id?: number;
    Guid?: string;
    ApplicationName?: string;
    MachineName?: string;
    CreationDate?: string;
    Type?: string;
    IsProtected?: number;
    Host?: string;
    Url?: string;
    HttpMethod?: string;
    IpAddress?: string;
    Source?: string;
    Message?: string;
    Detail?: string;
    StatusCode?: number;
    Sql?: string;
    DeletionDate?: string;
    FullJson?: string;
    ErrorHash?: number;
    DuplicateCount?: number;
}

export abstract class ExceptionsRow {
    static readonly idProperty = 'Id';
    static readonly nameProperty = 'Guid';
    static readonly localTextPrefix = 'Administration.Exceptions';
    static readonly deletePermission = 'Administration:General';
    static readonly insertPermission = 'Administration:General';
    static readonly readPermission = 'Administration:General';
    static readonly updatePermission = 'Administration:General';

    static readonly Fields = fieldsProxy<ExceptionsRow>();
}